import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ProductosService } from 'src/app/services/productos.service';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';

@Component({
  selector: 'app-nuevo-producto',
  templateUrl: './nuevo-producto.component.html',
  styleUrls: ['./nuevo-producto.component.scss']
})
export class NuevoProductoComponent implements OnInit {

  image: any;
  imageSrc: any;
  constructor(private prodSvc: ProductosService,
              private router: Router) { }

  newProductForm = new FormGroup({
    nombre: new FormControl('', Validators.required),
    categoria: new FormControl('', Validators.required),
    fechaCreacion: new FormControl(new Date().getTime()),
    imageProd: new FormControl('', Validators.required),
    descripcion: new FormControl(''),
    precio: new FormControl(''),
    amarillo: new FormControl(''),
    gris: new FormControl(''),
    azul: new FormControl(''),
    verde: new FormControl(''),
    rojo: new FormControl(''),
    negro: new FormControl(''),
    blanco: new FormControl(''),
    gr1000: new FormControl(''),
    gr1500: new FormControl(''),
    lt1: new FormControl(''),
    ltvalvula: new FormControl(''),
    ltrPist: new FormControl(''),
    ltrPistRep: new FormControl(''),
    ltr38: new FormControl(''),
    lt5: new FormControl(''),
    kg4: new FormControl(''),
    kg22: new FormControl(''),
    lt20: new FormControl(''),
    kg1: new FormControl(''),
    kg44: new FormControl(''),
    kg21: new FormControl(''),
    kiwi: new FormControl(''),
    sinAroma: new FormControl(''),
    citronela: new FormControl(''),
    floral: new FormControl(''),
    limon: new FormControl(''),
    lavanda: new FormControl(''),
    vinagre: new FormControl(''),
    frutosRojos: new FormControl(''),
    tL: new FormControl(''),
    tM: new FormControl(''),
    tS: new FormControl(''),
  });

  get nombreNoValido() {
    return this.newProductForm.get('nombre').invalid && this.newProductForm.get('nombre').touched;
  }
  get categoriaNoValido() {
    return this.newProductForm.get('categoria').invalid && this.newProductForm.get('categoria').touched;
  }


  ngOnInit(): void {
  }

  addNewProduct(producto: any){
    Swal.fire({
      title: 'Está seguro?',
      text: 'Se va a crear el producto en el sistema!',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, Crearlo!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.prodSvc.filterProd(producto, this.image);
        this.router.navigate(['GestionProductos']);
        Swal.fire(
          'Creado!',
          'Producto creado correctamente.',
          'success'
        );
      }
    });
  }

  handleImage(event: any){
    this.image = event.target.files[0];
    const reader = new FileReader();
    reader.onload = e => {
      this.imageSrc = reader.result;
    };
    reader.readAsDataURL(this.image);
  }


}
